import { coercePlacedMarkersArray } from './api';
import { DEFAULT_SELL_TIMBER_MARKER_ICON } from './sellTimberMarkerIcons';
import {
  SELL_TIMBER_GROT_MARKER_ICON,
  excludeGrotMarkerFromTimberPlacedMarkers,
  filterGrotBiobransleMarkers
} from './sellTimberShared';

export const MAP_MODES = {
  sections: 'sections',
  fellings: 'fellings',
  draw: 'draw',
  marker: 'marker'
};

export function buildStep2InitialState(initialMapState, mapPropertyCache, propertyRef) {
  const refStr = String(propertyRef ?? '');
  const cache =
    mapPropertyCache && String(mapPropertyCache.ref) === refStr ? mapPropertyCache : null;
  const cacheReady = cache?.propertyFetch?.status === 'success';

  const sectionsFromGeometry =
    Array.isArray(initialMapState?.sections) && initialMapState.sections.length > 0
      ? initialMapState.sections
      : null;
  const sections = cacheReady ? sectionsFromGeometry ?? cache.sections ?? [] : sectionsFromGeometry ?? [];

  const borderCoords =
    initialMapState?.borderCoords != null
      ? initialMapState.borderCoords
      : cacheReady
        ? cache.borderCoords
        : null;

  const propertyGeojson = cacheReady ? cache.propertyGeojson : null;

  const fellingFromGeometry = initialMapState?.fellingApplicationsGeojson;
  const fellingApplicationsGeojson = cacheReady
    ? fellingFromGeometry ?? cache.fellingApplicationsGeojson
    : fellingFromGeometry ?? null;

  let propertyFetch;
  if (cache?.propertyFetch?.status === 'loading') {
    propertyFetch = { status: 'loading', error: null };
  } else if (cache?.propertyFetch?.status === 'error') {
    propertyFetch = cache.propertyFetch;
  } else if (cacheReady) {
    propertyFetch = cache.propertyFetch;
  } else {
    propertyFetch = { status: 'idle', error: null };
  }

  let fellingFetch;
  if (cacheReady) {
    fellingFetch = cache.fellingFetch;
  } else {
    fellingFetch = { status: 'idle', error: null };
  }

  return {
    mapMode: initialMapState?.mapMode ?? MAP_MODES.sections,
    sections,
    borderCoords,
    propertyGeojson,
    fellingApplicationsGeojson,
    selectedSectionLocalIds: [...(initialMapState?.selectedSectionLocalIds ?? [])],
    selectedFellingApplicationIds: (initialMapState?.selectedFellingApplicationIds ?? []).map(String),
    drawnPolygons: [...(initialMapState?.drawnPolygons ?? [])],
    placedMarkers: excludeGrotMarkerFromTimberPlacedMarkers(
      coercePlacedMarkersArray(initialMapState)
    ),
    markerMoveTargetId: null,
    customAreaFromAd: initialMapState?.customAreaFromAd ?? null,
    propertyFetch,
    fellingFetch,
    continueError: null,
    removeMode: false,
    selectedMarkerIcon:
      initialMapState?.selectedMarkerIcon === SELL_TIMBER_GROT_MARKER_ICON
        ? DEFAULT_SELL_TIMBER_MARKER_ICON
        : (initialMapState?.selectedMarkerIcon ?? DEFAULT_SELL_TIMBER_MARKER_ICON)
  };
}

/** Grot step 2: marker mode only; one or more Biobränsle markers. */
export function buildGrotStep2InitialState(initialMapState, mapPropertyCache, propertyRef) {
  const base = buildStep2InitialState(initialMapState, mapPropertyCache, propertyRef);
  return {
    ...base,
    mapMode: MAP_MODES.marker,
    placedMarkers: filterGrotBiobransleMarkers(coercePlacedMarkersArray(initialMapState)),
    markerMoveTargetId: null,
    selectedSectionLocalIds: [],
    selectedFellingApplicationIds: [],
    drawnPolygons: [],
    customAreaFromAd: null,
    removeMode: false,
    selectedMarkerIcon: SELL_TIMBER_GROT_MARKER_ICON
  };
}
